import { useState } from "react";
import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import MatchPayslipDocumentToEmployeeRequest from "../request/MatchPayslipDocumentToEmployeeRequest";
import { queryClient } from "../../../../App";

const MatchPayslipDocumentToEmployeeApiService = async (
  request: MatchPayslipDocumentToEmployeeRequest
): Promise<boolean> => {
  const url = `/document_processing_jobs/${request.job_id}/match/`;
  const { data } = await axios.post(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useMatchPayslipDocumentToEmployeeApiService = (request: number) => {
  const [customLoading, setCustomLoading] = useState(false);

  const { mutate, isSuccess, isError, error } = useMutation<
    boolean,
    AxiosError,
    MatchPayslipDocumentToEmployeeRequest
  >(MatchPayslipDocumentToEmployeeApiService, {
    onMutate: async () => {
      setCustomLoading(true); // Set custom loading state before mutation
    },
    onSuccess: async () => {
      // Invalidate and refetch
      await queryClient.invalidateQueries([
        "DocumentUploadDetailsApiService",
        {
          id: request,
          search: "",
        },
      ]);
      await queryClient.invalidateQueries(["DocumentUploadDetailsApiService"]);
      await queryClient.invalidateQueries(["EmployeeListSearchApiService"]);
      await queryClient.invalidateQueries(["CrossBatchSearchApiService"]);
      setCustomLoading(false); // Reset custom loading state after all invalidations
    },
    onError: () => {
      setCustomLoading(false); // Ensure loading is also false on error
    },
  });

  return { mutate, isSuccess, isError, error, isLoading: customLoading };
};

export default useMatchPayslipDocumentToEmployeeApiService;
